import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { formatNumberUsingUnit } from '../../../utils/formatUtils';
import ComparisonPeriodPicker from '../../../components/DatePicker/ComparisonPeriodPicker';
import { columnsArray, columnsArrayYTD, columnsRegion } from '../../../data/overallPerformanceData';
import {
  OVERALL_PERFORMANCE,
  OVERALL_PERFORMANCE_SUB_BRANCH,
  TABLE_PERIOD_COMPARE,
  TABLE_YTD,
} from '../../../constants/datePickerConstants';

// Cell component with PropTypes
const PercentageCell = ({ cell }) => <span>{formatNumberUsingUnit(cell.value, '%')}</span>;

PercentageCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
};

export function useTableOneColumns({ subBranchDashboard }) {
  const { compareFilter } = useSelector((state) => state.overallPerformance);

  return useMemo(() => {
    return [
      ...columnsArray,
      {
        Header: (
          <ComparisonPeriodPicker
            component={subBranchDashboard ? OVERALL_PERFORMANCE_SUB_BRANCH : OVERALL_PERFORMANCE}
            comparePeriod={compareFilter}
            tableType={TABLE_PERIOD_COMPARE}
          />
        ),
        accessor: 'percentToPrevYear',
        Cell: PercentageCell,
      },
    ];
  }, [compareFilter]);
}

export function useTableTwoColumns({ subBranchDashboard }) {
  const { compareFilter } = useSelector((state) => state.overallPerformance);
  const { userData } = useSelector((state) => state.auth);

  return useMemo(() => {
    // Set the dynamic year in the header
    const modifiedColumns = [...columnsArrayYTD];
    modifiedColumns[1].Header = `YTD view ${userData?.data?.current_year}`;

    return [
      ...modifiedColumns,
      {
        Header: (
          <ComparisonPeriodPicker
            component={subBranchDashboard ? OVERALL_PERFORMANCE_SUB_BRANCH : OVERALL_PERFORMANCE}
            comparePeriod={compareFilter}
            tableType={TABLE_YTD}
          />
        ),
        accessor: 'percentToPrevYear',
        Cell: PercentageCell,
      },
    ];
  }, [compareFilter, userData?.data?.current_year]);
}

export function useTableThreeColumns() {
  return useMemo(() => columnsRegion, []);
}
